'use client'

import { type CSSProperties, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

const WATERMARK_URL =
  'https://usertourkit.com/pricing?utm_source=unlicensed_badge&utm_medium=in_app&utm_campaign=watermark'

const wrapperStyle: CSSProperties = {
  position: 'fixed',
  right: '16px',
  bottom: '16px',
  zIndex: 2147483647,
  pointerEvents: 'none',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
}

const linkStyle: CSSProperties = {
  pointerEvents: 'auto',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  padding: '6px 10px',
  borderRadius: '8px',
  background: 'rgba(17, 24, 39, 0.92)',
  color: '#fff',
  fontSize: '12px',
  lineHeight: 1.2,
  textDecoration: 'none',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
}

const logoStyle: CSSProperties = {
  width: '14px',
  height: '14px',
  flexShrink: 0,
}

const labelStyle: CSSProperties = {
  fontWeight: 600,
}

const ctaStyle: CSSProperties = {
  marginLeft: '6px',
  opacity: 0.85,
  textDecoration: 'underline',
}

function UserTourKitLogo() {
  return (
    <svg
      style={logoStyle}
      viewBox="0 0 926 1342"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M637.387 360.13C637.387 374.436 625.773 386.063 611.467 386.063H314.227C299.933 386.063 288.307 374.436 288.307 360.13C288.307 345.85 299.933 334.223 314.227 334.223H611.467C625.773 334.223 637.387 345.85 637.387 360.13Z"
        fill="#FFE20A"
      />
      <path
        d="M552.533 205.048V280.568H373.16V205.048C373.16 155.595 413.387 115.355 462.853 115.355C512.307 115.355 552.533 155.595 552.533 205.048Z"
        fill="#FFE20A"
      />
      <path
        d="M309.12 528.716L268.013 828.143C242.453 830.89 217.32 838.05 194.227 849.237C147.24 872.01 93.3601 872.01 46.3734 849.237L0 826.743V564.53C0 544.756 16.0267 528.716 35.8 528.716H309.12Z"
        fill="#0197F6"
      />
      <path
        d="M925.707 564.53V826.743L879.333 849.237C832.64 871.85 779.16 872.01 732.4 849.677L731.453 849.223C708.373 838.037 683.24 830.89 657.68 828.143L616.573 528.717H889.907C909.68 528.717 925.707 544.757 925.707 564.53Z"
        fill="#0197F6"
      />
      <path
        d="M813.68 1181.04C726.36 1282.76 599.44 1341.85 462.853 1341.85C326.253 1341.85 199.347 1282.76 112.027 1181.04C148.187 1182.36 184.56 1174.93 217.64 1158.89C240.56 1147.8 266.12 1141.92 291.573 1141.92C316.573 1141.92 341.68 1147.57 364.267 1158.3L365.507 1158.89C395.667 1173.52 429.32 1181.25 462.853 1181.25C496.333 1181.25 529.96 1173.53 560.08 1158.94L560.187 1158.89C606.867 1136.26 660.36 1136.12 707.12 1158.44L708.067 1158.89C741.147 1174.93 777.52 1182.36 813.68 1181.04Z"
        fill="#0197F6"
      />
      <path
        d="M925.64 886.41C924.333 968.836 901.293 1048.9 858.707 1118.98C817.36 1132.68 771.84 1129.89 732.373 1111.06L731.453 1110.62C701.307 1096 667.64 1088.26 634.12 1088.26C600.627 1088.26 566.973 1096 536.84 1110.58L536.773 1110.62C490.24 1133.2 436.893 1133.38 390.213 1111.25L388.907 1110.61C358.747 1096 325.08 1088.26 291.574 1088.26C258.054 1088.26 224.4 1096 194.227 1110.62C154.56 1129.85 108.667 1132.78 67.0001 1118.98C24.4134 1048.9 1.36013 968.836 0.0534668 886.41L22.9602 897.517C53.1336 912.143 86.7869 919.863 120.294 919.863C153.827 919.863 187.48 912.143 217.64 897.517C240.534 886.41 266.107 880.543 291.574 880.543C317.04 880.543 342.613 886.41 365.52 897.517C395.68 912.143 429.333 919.863 462.853 919.863C496.32 919.863 529.933 912.157 560.067 897.57L560.187 897.503C606.867 874.89 660.36 874.717 707.133 897.063L708.067 897.517C738.213 912.143 771.88 919.863 805.4 919.863C838.92 919.863 872.573 912.143 902.733 897.517L925.64 886.41Z"
        fill="#0197F6"
      />
      <path
        d="M798.72 280.568H625.974C611.16 280.568 599.16 268.554 599.16 253.741C599.16 238.928 611.16 226.915 625.974 226.915H798.72C813.534 226.915 825.534 238.928 825.534 253.741C825.534 268.554 813.534 280.568 798.72 280.568Z"
        fill="#0197F6"
      />
      <path
        d="M582.947 135.515C574.987 123.021 578.64 106.434 591.133 98.4744L738.853 4.20775C751.347 -3.75225 767.933 -0.085535 775.893 12.3945C783.867 24.8878 780.2 41.4745 767.707 49.4478L620 143.701C607.507 151.661 590.92 148.008 582.947 135.515Z"
        fill="#0197F6"
      />
      <path
        d="M299.72 280.568H126.987C112.173 280.568 100.173 268.554 100.173 253.741C100.173 238.928 112.173 226.915 126.987 226.915H299.72C314.547 226.915 326.547 238.928 326.547 253.741C326.547 268.554 314.547 280.568 299.72 280.568Z"
        fill="#0197F6"
      />
      <path
        d="M305.707 143.701L158 49.4478C145.507 41.4745 141.84 24.8878 149.813 12.3945C157.773 -0.085535 174.36 -3.75225 186.853 4.20775L334.574 98.4744C347.067 106.434 350.72 123.021 342.76 135.515C334.787 148.008 318.2 151.661 305.707 143.701Z"
        fill="#0197F6"
      />
      <path
        d="M503.213 638.796C503.213 643.29 499.573 646.93 495.093 646.93H430.613C426.133 646.93 422.493 643.29 422.493 638.796V596.583C422.493 574.29 440.56 556.223 462.853 556.223C474 556.223 484.093 560.73 491.387 568.036C498.693 575.343 503.213 585.436 503.213 596.583V638.796ZM550.2 439.703H375.507L322.04 829.01C345.213 832.223 367.907 839.05 388.92 849.236C411.827 860.343 437.4 866.21 462.853 866.21C488.307 866.21 513.867 860.343 536.773 849.236L536.787 849.223C536.787 849.223 536.787 849.223 536.8 849.223L536.867 849.196C557.853 839.023 580.52 832.196 603.653 828.996L550.2 439.703Z"
        fill="#FFE20A"
      />
    </svg>
  )
}

type WindowWithAnalytics = Window & {
  gtag?: (event: 'event', name: string, params: Record<string, unknown>) => void
  dataLayer?: Array<Record<string, unknown>>
}

type WatermarkInstance = {
  id: symbol
  setOwner: (isOwner: boolean) => void
}

const instances: WatermarkInstance[] = []
let ownerId: symbol | null = null

function electOwner(): void {
  ownerId = instances[0]?.id ?? null
  for (const instance of instances) {
    instance.setOwner(instance.id === ownerId)
  }
}

function dispatchClickEvent(): void {
  if (typeof window === 'undefined') return

  const win = window as WindowWithAnalytics
  const hostname = window.location?.hostname ?? ''
  const payload = {
    placement: 'watermark',
    hostname,
  }

  try {
    if (typeof win.gtag === 'function') {
      win.gtag('event', 'unlicensed_badge_clicked', payload)
      return
    }
    if (Array.isArray(win.dataLayer)) {
      win.dataLayer.push({ event: 'unlicensed_badge_clicked', ...payload })
    }
  } catch {
    // Analytics dispatch must never throw.
  }
}

export function LicenseWatermark() {
  const [isOwner, setIsOwner] = useState(false)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    const entry: WatermarkInstance = {
      id: Symbol('watermark'),
      setOwner: setIsOwner,
    }
    instances.push(entry)
    electOwner()

    return () => {
      const idx = instances.findIndex((x) => x.id === entry.id)
      if (idx !== -1) instances.splice(idx, 1)
      electOwner()
    }
  }, [])

  if (!mounted || !isOwner) return null
  if (typeof document === 'undefined') return null

  return createPortal(
    <section
      data-tourkit-watermark=""
      aria-label="userTourKit license required"
      style={wrapperStyle}
    >
      <a
        href={WATERMARK_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={linkStyle}
        onClick={dispatchClickEvent}
        aria-label="userTourKit unlicensed — remove this badge with a one-time $99 license"
      >
        <UserTourKitLogo />
        <span style={labelStyle}>userTourKit</span>
        <span aria-hidden="true">·</span>
        <span>Unlicensed</span>
        <span style={ctaStyle}>Remove for $99</span>
      </a>
    </section>,
    document.body
  )
}
